export const getURLDate = (dateString: string): string => {
    const date = Date.fromISO(dateString);
    return date ? `/${date.formatDate("YYYYMMdd")}` : "";
}